export const  availablePermissions = {
    "Dashboard": true,
    "Offer And Banner Management":true,
    "Category Management" :true,
    "Product Management":true,
    "Dealer Management":true,
    "Customer Management":true,
    "Order Management":true,
    "Delivery Partner Management":true,
    "Payment Management":true,
    "Email Template Management":true,
    "Notification Management":true,
    "Rate & Review Management":true,
    "Reports & Analytics Management": true,
    "CMS Management" :true,
    "FAQ Management":true,
    "Subadmin Management":true,
    // "Time Slot Management":true,
    "Dealer Commission Management": true,
    "Currency Management" : true,
    "Language Management" : true,
}